(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2999],{

/***/ 63085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ShopVerticalCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89670);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22120);
/* harmony import */ var utils_getShopTodaySchedule__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5864);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _shopVerticalCard_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93070);
/* harmony import */ var _shopVerticalCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shopVerticalCard_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var utils_shopHref__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76896);







 // ✅ aggiunto import
function ShopVerticalCard(param) {
    let { data  } = param;
    var ref, ref1;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const today = (0,utils_getShopTodaySchedule__WEBPACK_IMPORTED_MODULE_4__/* .getSchedule */ .M)(data);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        href: (0,utils_shopHref__WEBPACK_IMPORTED_MODULE_6__/* .shopHref */ .E)(data),
        className: (_shopVerticalCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container),
        children: [
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_shopVerticalCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().imageContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: (data === null || data === void 0 ? void 0 : data.logo_img) || "",
                    alt: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                    fill: true,
                    quality: 90,
                    sizes: "80px"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_shopVerticalCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().body),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: (_shopVerticalCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                        children: data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: (_shopVerticalCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().description),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
                                size: 13
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: !(today === null || today === void 0 ? void 0 : today.disabled) && (data === null || data === void 0 ? void 0 : data.open) ? "".concat(t("by"), " ").concat((today === null || today === void 0 ? void 0 : today.from) || t("N/A")) : t("closed")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 22999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ VisitedShops; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30719);
/* harmony import */ var components_shopCard_shopVerticalCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63085);
/* harmony import */ var _visitedShops_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91013);
/* harmony import */ var _visitedShops_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_visitedShops_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22120);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71911);






function VisitedShops(param) {
    let { data  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_visitedShops_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: (_visitedShops_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
                children: t("recently.visited")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
                slidesPerView: "auto",
                spaceBetween: 20,
                lazy: true,
                modules: [
                    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Lazy */ .oM
                ],
                children: data === null || data === void 0 ? void 0 : data.map((shop)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
                        className: (_visitedShops_module_scss__WEBPACK_IMPORTED_MODULE_5___default().swiperSlide),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shopCard_shopVerticalCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            data: shop
                        })
                    }, shop.id))
            })
        ]
    });
}


/***/ }),

/***/ 5864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getSchedule; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

function getSchedule(data) {
    var ref;
    return data === null || data === void 0 ? void 0 : (ref = data.shop_working_days) === null || ref === void 0 ? void 0 : ref.find((item)=>{
        var ref;
        return ((ref = item.day) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === dayjs__WEBPACK_IMPORTED_MODULE_0___default()().format("dddd").toLowerCase();
    });
}


/***/ }),

/***/ 93070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"shopVerticalCard_container___DgUK","imageContainer":"shopVerticalCard_imageContainer__dH1H4","body":"shopVerticalCard_body__UW6PH","title":"shopVerticalCard_title__um3k5","description":"shopVerticalCard_description__mPQI6"};

/***/ }),

/***/ 91013:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"visitedShops_container__qbiYN","title":"visitedShops_title__iJaWE","swiperSlide":"visitedShops_swiperSlide__tRyiz"};

/***/ })

}]);